module.exports = __webpack_public_path__ + "img/8A.bc097f1f.jpg";